// extracted by mini-css-extract-plugin
module.exports = {"Print-Button":"print-button_Print-Button__M5KCD"};